import React, { useState} from 'react';
import { Tab, Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useSelector }from 'react-redux';
import { handleValidateCodevalue,TEMPLATE_TABS } from '../../Utility/constant';
import BiztantuCampaign from '../Campaign';
import EmailToTaskDialog from '../Configuration/Tasks/EmailToTaskDialog';
import EmailSettings from '../Profile/EmailSettings';
import WhatsappSettings from '../../Components/WhatsappSettings';
import TelecallingSettings from '../../Components/TeleCalling';
import WebToLead from './WebToLead';
import TemplatesTab from './TemplatesTab';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import history from '../../Utility/history';
import { i18nRegistry } from '../../Utility/i18nRegistry';
import './template.css';



const BiztantuEmailTemplate = ({}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [selectionModel, setSelectionModel] = React.useState([]);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
const location = useLocation();
    const templateData  = useSelector(state => state?.template?.template);
    const [activeTab, setActiveTab] = useState('TAB_TEMPLATES');

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        i18nRegistry.clear();
            if (newValue !== TEMPLATE_TABS?.TAB_TEMPLATES) {
            history.replace({
            pathname: location.pathname,
            search: location.search,
            state: {
                ...location.state,
            },
        });
    }
    };

const tabsConfig = [
  {
    value: TEMPLATE_TABS?.TAB_TEMPLATES,
    labelKey: TEMPLATE_TABS?.TAB_TEMPLATES,
    defaultLabel: "Templates",
  },
  {
    value: TEMPLATE_TABS?.TAB_PROMOTIONS,
    labelKey: TEMPLATE_TABS?.TAB_PROMOTIONS,
    defaultLabel: "Promotions",
    condition: specificRolePermission?.isNotificationView,
  },
  {
    value: TEMPLATE_TABS?.TAB_USER_EMAIL_SETTING,
    labelKey: TEMPLATE_TABS?.TAB_USER_EMAIL_SETTING,
  },
  {
    value: TEMPLATE_TABS?.TAB_EMAIL_TO_TASK,
    labelKey: TEMPLATE_TABS?.TAB_EMAIL_TO_TASK,
  },
   {
    value: TEMPLATE_TABS?.TAB_WEB_TO_LEAD,
    labelKey: TEMPLATE_TABS?.TAB_WEB_TO_LEAD
  },
  {
    value: TEMPLATE_TABS?.TAB_WHATSAPP_SETTINGS,
    labelKey: TEMPLATE_TABS?.TAB_WHATSAPP_SETTINGS,
  },
  {
    value: TEMPLATE_TABS?.TAB_TELECALLING_SETTINGS,
    labelKey: TEMPLATE_TABS?.TAB_TELECALLING_SETTINGS,
  },
];
    return (
        <Box className="template-tabs-container">
          <TabContext value={activeTab}>
            <Box className="template-tab-list">
              <TabList
                onChange={handleTabChange}
                variant="standard"
                aria-label="template tabs"
                allowScrollButtonsMobile
              >
                {tabsConfig.map((tab) => {
                  if (tab.condition === false) return null; 

                  return (
                    <Tab
                      key={tab.value}
                      value={tab.value}
                      label={
                        handleValidateCodevalue(internationalise, tab.labelKey) ||
                        tab.defaultLabel ||
                        tab.labelKey
                      }
                    />
                  );
                })}
              </TabList>
            </Box>
            <Box className="template-tab-content">
            <TabPanel value={TEMPLATE_TABS?.TAB_TEMPLATES}>
              <TemplatesTab/>
            </TabPanel>
            {specificRolePermission?.isNotificationView && (
              <TabPanel value={TEMPLATE_TABS?.TAB_PROMOTIONS}>
                <BiztantuCampaign />
              </TabPanel>
            )}
            <TabPanel value={TEMPLATE_TABS?.TAB_EMAIL_TO_TASK}>
                <EmailToTaskDialog
                        specificRolePermission={specificRolePermission}
                        dataGridData={templateData || []}
                        selectionModel={selectionModel}
                    />
              </TabPanel>
              <TabPanel value={TEMPLATE_TABS?.TAB_USER_EMAIL_SETTING}>
                {<EmailSettings/>}
              </TabPanel>
              <TabPanel value={TEMPLATE_TABS?.TAB_WHATSAPP_SETTINGS}>
                {<WhatsappSettings/>}
              </TabPanel>
              <TabPanel value={TEMPLATE_TABS?.TAB_TELECALLING_SETTINGS}>
                {<TelecallingSettings/>}
              </TabPanel>
              <TabPanel value={TEMPLATE_TABS?.TAB_WEB_TO_LEAD}>
                {<WebToLead/>}
              </TabPanel>
            </Box>
          </TabContext>
        </Box>
    )
}

export default BiztantuEmailTemplate